"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmenityService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token"],
  _excluded3 = ["token", "tenantId"],
  _excluded4 = ["token", "id"],
  _excluded5 = ["token", "tenantId"],
  _excluded6 = ["token", "tenantId"],
  _excluded7 = ["token", "tenantId"],
  _excluded8 = ["token"],
  _excluded9 = ["token"],
  _excluded10 = ["token", "id"],
  _excluded11 = ["token", "id"],
  _excluded12 = ["token"],
  _excluded13 = ["token"],
  _excluded14 = ["token", "id"],
  _excluded15 = ["token", "id"],
  _excluded16 = ["token", "tenantId", "id"],
  _excluded17 = ["token", "amenity"],
  _excluded18 = ["token", "id"],
  _excluded19 = ["token", "id"],
  _excluded20 = ["token", "amenity"],
  _excluded21 = ["token", "amenity"],
  _excluded22 = ["token", "amenity"],
  _excluded23 = ["token", "id"],
  _excluded24 = ["token", "id"],
  _excluded25 = ["token", "id", "tenantId"],
  _excluded26 = ["token", "id", "tenantId"],
  _excluded27 = ["token", "id", "tenantId"],
  _excluded28 = ["token", "tenantId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AmenityService = exports.AmenityService = /*#__PURE__*/(0, _createClass2["default"])(function AmenityService() {
  (0, _classCallCheck2["default"])(this, AmenityService);
});
(0, _defineProperty2["default"])(AmenityService, "amenitiesUsageByDay", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get('/dashboard/amenity/usageByDay', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "amenitiesUsageByAmenity", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).get('/dashboard/amenity/usageByAmenity', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "list", function (_ref3) {
  var token = _ref3.token,
    tenantId = _ref3.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token, tenantId).get('/management/amenity', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "delete", function (_ref4) {
  var token = _ref4.token,
    id = _ref4.id,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token)["delete"]("/amenity/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "listReservations", function (_ref5) {
  var token = _ref5.token,
    tenantId = _ref5.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token, tenantId).get('/amenity/reservation', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "listAcceptedReservations", function (_ref6) {
  var token = _ref6.token,
    tenantId = _ref6.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token, tenantId).get('/management/amenity/reservation/accepted', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "listPendingReservations", function (_ref7) {
  var token = _ref7.token,
    tenantId = _ref7.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return _Api["default"].withAuth(token, tenantId).get('/management/amenity/reservation/pending', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "create", function (_ref8) {
  var token = _ref8.token,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded8);
  return _Api["default"].withAuth(token).post('/amenity', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "listAmenitiesStockMovements", function (_ref9) {
  var token = _ref9.token,
    params = (0, _objectWithoutProperties2["default"])(_ref9, _excluded9);
  return _Api["default"].withAuth(token).get('/amenity/stock/movement', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "replenishStock", function (_ref10) {
  var token = _ref10.token,
    id = _ref10.id,
    params = (0, _objectWithoutProperties2["default"])(_ref10, _excluded10);
  return _Api["default"].withAuth(token).post("/amenity/".concat(id, "/stock/replenish"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "debitStock", function (_ref11) {
  var token = _ref11.token,
    id = _ref11.id,
    params = (0, _objectWithoutProperties2["default"])(_ref11, _excluded11);
  return _Api["default"].withAuth(token).post("/amenity/".concat(id, "/stock/debit"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "listAmenitiesEntries", function (_ref12) {
  var token = _ref12.token,
    params = (0, _objectWithoutProperties2["default"])(_ref12, _excluded12);
  return _Api["default"].withAuth(token).get('/amenity/entry', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "listPendingCheckouts", function (_ref13) {
  var token = _ref13.token,
    params = (0, _objectWithoutProperties2["default"])(_ref13, _excluded13);
  return _Api["default"].withAuth(token).get('/amenity/pendingCheckout', {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "checkout", function (_ref14) {
  var token = _ref14.token,
    id = _ref14.id,
    params = (0, _objectWithoutProperties2["default"])(_ref14, _excluded14);
  return _Api["default"].withAuth(token).post("/amenity/checkout/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "get", function (_ref15) {
  var token = _ref15.token,
    id = _ref15.id,
    params = (0, _objectWithoutProperties2["default"])(_ref15, _excluded15);
  return _Api["default"].withAuth(token).get("/amenity/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "edit", function (_ref16) {
  var token = _ref16.token,
    tenantId = _ref16.tenantId,
    id = _ref16.id,
    params = (0, _objectWithoutProperties2["default"])(_ref16, _excluded16);
  return _Api["default"].withAuth(token, tenantId).patch("/amenity/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "createAdminReservation", function (_ref17) {
  var token = _ref17.token,
    amenity = _ref17.amenity,
    params = (0, _objectWithoutProperties2["default"])(_ref17, _excluded17);
  return _Api["default"].withAuth(token).post("/amenity/".concat(amenity, "/reservation/admin"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "editReservation", function (_ref18) {
  var token = _ref18.token,
    id = _ref18.id,
    params = (0, _objectWithoutProperties2["default"])(_ref18, _excluded18);
  return _Api["default"].withAuth(token).patch("/amenity/reservation/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "deleteReservation", function (_ref19) {
  var token = _ref19.token,
    id = _ref19.id,
    params = (0, _objectWithoutProperties2["default"])(_ref19, _excluded19);
  return _Api["default"].withAuth(token)["delete"]("/amenity/reservation/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "getMonthAvailability", function (_ref20) {
  var token = _ref20.token,
    amenity = _ref20.amenity,
    params = (0, _objectWithoutProperties2["default"])(_ref20, _excluded20);
  return _Api["default"].withAuth(token).get("/amenity/".concat(amenity, "/availability/daysByMonth"), {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "getDayAvailability", function (_ref21) {
  var token = _ref21.token,
    amenity = _ref21.amenity,
    params = (0, _objectWithoutProperties2["default"])(_ref21, _excluded21);
  return _Api["default"].withAuth(token).get("/management/amenity/".concat(amenity, "/availability/periodsByDay"), {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "getReservationEndPeriods", function (_ref22) {
  var token = _ref22.token,
    amenity = _ref22.amenity,
    params = (0, _objectWithoutProperties2["default"])(_ref22, _excluded22);
  return _Api["default"].withAuth(token).get("/amenity/".concat(amenity, "/availability/endPeriodsByPeriod"), {
    params: params
  });
});
(0, _defineProperty2["default"])(AmenityService, "blockAmenity", function (_ref23) {
  var token = _ref23.token,
    id = _ref23.id,
    params = (0, _objectWithoutProperties2["default"])(_ref23, _excluded23);
  return _Api["default"].withAuth(token).post("/amenity/".concat(id, "/block"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "finishEntry", function (_ref24) {
  var token = _ref24.token,
    id = _ref24.id,
    params = (0, _objectWithoutProperties2["default"])(_ref24, _excluded24);
  return _Api["default"].withAuth(token).post("/amenity/entry/".concat(id, "/finish"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "generateLostStockReport", function (_ref25) {
  var token = _ref25.token,
    id = _ref25.id,
    tenantId = _ref25.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref25, _excluded25);
  return _Api["default"].withAuth(token, tenantId).post("/management/amenity/".concat(id, "/lostStock"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "acceptReservation", function (_ref26) {
  var token = _ref26.token,
    id = _ref26.id,
    tenantId = _ref26.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref26, _excluded26);
  return _Api["default"].withAuth(token, tenantId).post("/management/amenity/reservation/".concat(id, "/accept"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "rejectReservation", function (_ref27) {
  var token = _ref27.token,
    id = _ref27.id,
    tenantId = _ref27.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref27, _excluded27);
  return _Api["default"].withAuth(token, tenantId).post("/management/amenity/reservation/".concat(id, "/refuse"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AmenityService, "amenityAbility", function (_ref28) {
  var token = _ref28.token,
    tenantId = _ref28.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref28, _excluded28);
  return _Api["default"].withAuth(token, tenantId).get('/amenity/ability', {
    params: params
  });
});